import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Heart } from 'lucide-react';
import { DonationForm } from '../components/DonationForm';
const FEEP_IMG = 'https://cdn.magicpatterns.com/uploads/6Jqi6t9HeDymL6x7JQUrSp/IMG_1798.jpg';
export function Donaciones() {
  return <div className="py-12 md:py-20" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
        {/* Editorial Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16 md:mb-24 bg-cafe-card rounded-3xl overflow-hidden shadow-soft border border-cafe-border/50" data-id="element-282">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center" data-id="element-283">
            <div className="aspect-[4/3] md:aspect-square lg:aspect-[4/3] overflow-hidden" data-id="element-284">
              <img src={FEEP_IMG} alt="Bandera de Trastienda Café en el campo base del Everest" className="w-full h-full object-cover" data-id="element-285" />
            </div>
            <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-286">
              <blockquote className="text-xl md:text-2xl lg:text-3xl font-serif text-cafe-primary italic leading-relaxed mb-6" data-id="element-287">
                «La causa de FEEP nos acompaña hasta donde nos llevemos. Esta
                bandera de Trastienda Café ondeó en el campo base del Everest
                junto a la Fundación Española de Enfermedades Priónicas.»
              </blockquote>
              <cite className="text-cafe-accent font-medium not-italic flex items-center gap-3" data-id="element-288">
                <div className="w-8 h-px bg-cafe-accent" data-id="element-289"></div>
                @fundacionprionicas
              </cite>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-290">
          {/* Info Section */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="space-y-8" data-id="element-291">
            <div data-id="element-292">
              <div className="inline-flex items-center space-x-2 bg-cafe-card px-4 py-2 rounded-full text-cafe-accent text-sm font-medium mb-6" data-id="element-293">
                <Heart size={16} className="fill-cafe-accent" data-id="element-294" />
                <span data-id="element-295">Causa Solidaria</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-serif text-cafe-primary mb-6" data-id="element-296">
                Apoyamos a la FEEP
              </h1>
              <div className="w-20 h-px bg-cafe-accent mb-8" data-id="element-297"></div>
            </div>
            <div className="prose prose-stone text-cafe-text/80" data-id="element-298">
              <p className="text-lg leading-relaxed" data-id="element-299">
                En Trastienda Café creemos en la importancia de contribuir a
                nuestra sociedad. Por ello, colaboramos activamente con la{' '}
                <strong data-id="element-300">
                  Fundación Española de Enfermedades Priónicas (FEEP)
                </strong>
                .
              </p>
              <p data-id="element-301">
                Las enfermedades priónicas son trastornos neurodegenerativos
                poco frecuentes y actualmente sin cura. La FEEP trabaja
                incansablemente para promover la investigación, apoyar a las
                familias afectadas y dar visibilidad a esta causa.
              </p>
              <p className="font-medium text-cafe-primary" data-id="element-302">
                El 100% de las donaciones realizadas a través de esta plataforma
                se destinan íntegramente a la Fundación.
              </p>
            </div>
            <div className="pt-6" data-id="element-303">
              <a href="https://priones.org" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-cafe-accent hover:text-cafe-primary font-medium transition-colors group" data-id="element-304">
                Visitar la web oficial de FEEP
                <ExternalLink size={18} className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-305" />
              </a>
            </div>
          </motion.div>
          {/* Form Section */}
          <div className="lg:mt-0 mt-8" data-id="element-306">
            <DonationForm data-id="element-307" />
          </div>
        </div>
      </div>
    </div>;
}